let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lTtPK")).then(() => parcelRequire('ioUY8'));